// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__xGlKt","spin":"styles_spin__X+xKc","stateView":"styles_stateView__tAvW4","errorMessage":"styles_errorMessage__q39aO"};